/**
 * Handle flyout menu JS for main menu.
 */
const handleFlyoutMenu = () => {
  const menuItems = document.querySelectorAll( '[data-parent="true"]' )
  menuItems.forEach( menuItem => {
    const link = menuItem.querySelector( 'a' )
    const submenu = menuItem.querySelector( '.hidden' )
    const button = menuItem.querySelector( 'button' )
    menuItem.addEventListener( 'mouseover', () => {
      menuItem.classList.add( 'open' )
      if ( link ) link.setAttribute( 'aria-expanded', 'true' )
      if ( button ) button.setAttribute( 'aria-expanded', 'true' )
      if ( submenu ) submenu.classList.remove( 'hidden' )
    } )
    menuItem.addEventListener( 'mouseout', () => {
      menuItem.classList.remove( 'open' )
      if ( link ) link.setAttribute( 'aria-expanded', 'false' )
      if ( button ) button.setAttribute( 'aria-expanded', 'false' )
      if ( submenu ) submenu.classList.add( 'hidden' )
    } )
    if ( button ) {
      button.addEventListener( 'click', () => {
        menuItem.classList.toggle( 'open' )
        if ( submenu ) submenu.classList.toggle( 'hidden' )
      } )
    }
  } )
}

export default handleFlyoutMenu
